/**
 * Dashboard Sidebar Toggle
 *
 * 響應式 sidebar：
 * - 桌面 (lg+)：永遠展開（寬度由 layout 決定）
 * - 手機 (< lg)：隱藏，點 header 下方的選單列以 overlay 展開
 *
 * 選單列（dashboard/_mobile_menu_bar.html.erb）的頁名由這裡填入，
 * 取自側邊欄目前高亮的連結，所以不會和側邊欄的文字不一致。
 */

import { trackEvent } from 'utils/analytics';

// The shared sidebar (TeamSidebar) marks its active entry with aria-current.
const ACTIVE_LINK_SELECTOR = 'a[aria-current="page"]';

function fillPageName(sidebar, menuBar) {
  const pageName = menuBar.querySelector('[data-mobile-menu-page-name]');
  const activeLink = sidebar.querySelector(ACTIVE_LINK_SELECTOR);
  if (!pageName || !activeLink) return;

  // title 只有頁名；連結文字可能夾著未讀數的 badge
  pageName.textContent = (activeLink.getAttribute('title') || activeLink.textContent).trim();
}

function reportMenuOpen(menuBar) {
  try {
    trackEvent('dashboard_menu_open', { dashboard: menuBar.dataset.analyticsScope });
  } catch (error) {
    // 追蹤失敗不能擋住 drawer
    console.error('[Sidebar] menu open tracking failed:', error);
  }
}

export function initSidebarToggle() {
  const sidebar = document.querySelector('.dashboard-sidebar');
  if (!sidebar) return;

  const menuBar = document.querySelector('[data-sidebar-hamburger]');
  const backdrop = document.querySelector('[data-sidebar-backdrop]');
  if (!menuBar || !backdrop) return;

  fillPageName(sidebar, menuBar);

  // Menu bar click → expand as overlay
  menuBar.addEventListener('click', () => {
    // Already open (a keyboard press can reach the bar behind the backdrop)
    if (sidebar.classList.contains('fixed')) return;

    reportMenuOpen(menuBar);
    sidebar.classList.remove('w-0', 'overflow-hidden');
    sidebar.classList.add('fixed', 'left-0', 'top-0', 'bottom-0', drawerWidth(sidebar), 'z-40', 'shadow-lg', 'overflow-y-auto');
    backdrop.classList.remove('hidden');
    // The drawer is shorter than the closed sidebar: keep the current entry in sight.
    // Centered, because a page's own fixed bottom bar (the profile) covers the edge.
    sidebar.querySelector(ACTIVE_LINK_SELECTOR)?.scrollIntoView({ block: 'center' });
  });

  // Backdrop click → collapse
  backdrop.addEventListener('click', () => {
    closeOverlay(sidebar, backdrop);
  });

  // Escape key closes overlay
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && sidebar.classList.contains('fixed')) {
      closeOverlay(sidebar, backdrop);
    }
  });
}

// The shared sidebar is as wide as on the team dashboard.
function drawerWidth(sidebar) {
  return sidebar.dataset.drawerWidth || 'w-48';
}

function closeOverlay(sidebar, backdrop) {
  sidebar.classList.remove('fixed', 'left-0', 'top-0', 'bottom-0', 'z-40', 'shadow-lg', drawerWidth(sidebar), 'overflow-y-auto');
  sidebar.classList.add('w-0', 'overflow-hidden');
  backdrop.classList.add('hidden');
}

document.addEventListener('DOMContentLoaded', initSidebarToggle);
